import { Injectable } from '@angular/core';
import { HttpService } from "./http.service";
import { CreateResult } from "../models/create-result";
import { debug } from 'util';
import { UserDataStoreService } from './user-data-store.service';
import { AuditMerchantViewModel } from '../models/audit-merchant-view-model';
import { AuditBankingDetailsViewModel } from '../models/audit-bank-details-view-model';
import { AuditContactDetailsViewModel } from '../models/audit-contact-details-view-model';
import { AuditCommissionDetailsViewModel } from '../models/audit-commission-details-view-model';
import { AuditVASCustomerDetailsViewModel } from '../models/audit-vas-customer-details-view-model';
import { AuditVasDetailsViewModel } from '../models/audit-vas-details-view-model';
import { AuditTeminalDetailsViewModel } from '../models/audit-teminal-details-view-model';
import { AuditTerminalInteractionViewModel } from '../models/audit-teminal-interaction-details-view-model';
import { AuditSinkNodeMappedFieldsDetailsViewModel } from '../models/audit-sink-node-mapped-fields-details-view-model';
import { AuditCardAcceptorConfigViewModel } from '../models/audit-trail-card-acceptor-config-view-model';
import { TerminalConfigViewModel } from '../models/terminal-config-view-model';
import { AuditTerminalConfigViewModel } from '../models/audit-trail-terminal-config-view-model';
import { AuditUserViewModel } from "../models/audit-user-view-model";
import { AuditRoleViewModel } from "../models/audit-role-view-model";
import { AuditTeminalCustomParameterViewModel } from '../models/audit-teminal-custom-parameter-view-model';
import { AuditStructualDataDetailsViewModel } from '../models/audit-structural-data-details-view-model';
import { AuditPackedStructualDataDetailsViewModel } from '../models/audit-packed-structural-data-details-view-model';
import { AuditMerchantParamsViewModel } from '../models/audit-merchant-params-view-model';
import { AuditLogViewModel } from '../models/audit-log-view-model';

@Injectable({
  providedIn: 'root'
})
export class AuditService {

  constructor(private _httpService: HttpService, private _userDataStore: UserDataStoreService) {
  }


  public async GetUserLogs(): Promise<AuditUserViewModel[]> {
    const httpResult = await this._httpService.apiGet<AuditUserViewModel[]>(`audit/GetUserLogs`);
    if (httpResult && httpResult.body) {
      return httpResult.body;
    }
    return [];
  }

  public async GetRoleLogs(): Promise<AuditRoleViewModel[]> {
    const httpResult = await this._httpService.apiGet<AuditRoleViewModel[]>(`audit/GetRoleLogs`);
    if (httpResult && httpResult.body) {
      return httpResult.body;
    }
    return [];
  }

  public async GetMerchantDetails(id: string): Promise<AuditMerchantViewModel[]> {
    const httpResult = await this._httpService.apiGet<AuditMerchantViewModel[]>(`audit/GetMerchant/${id}`);
    if (httpResult && httpResult.body) {
      return httpResult.body;
    }
    return [];
  }

  public async GetBankingDetails(id: string): Promise<AuditBankingDetailsViewModel[]> {

    const httpResult = await this._httpService.apiGet<AuditBankingDetailsViewModel[]>(`audit/GetBankingDetails/${id}`);
    if (httpResult && httpResult.body) {
      return httpResult.body;
    }
    return [];
  }

  public async GetContactDetails(id: string): Promise<AuditContactDetailsViewModel[]> {
    const httpResult = await this._httpService.apiGet<AuditContactDetailsViewModel[]>(`audit/GetContactDetails/${id}`);
    if (httpResult && httpResult.body) {
      return httpResult.body;
    }
    return [];
  }

  public async GetCommissionDetails(id: string): Promise<AuditCommissionDetailsViewModel[]> {
    const httpResult = await this._httpService.apiGet<AuditCommissionDetailsViewModel[]>(`audit/GetCommissionDetails/${id}`);
    if (httpResult && httpResult.body) {
      return httpResult.body;
    }
    return [];
  }

  public async GetVASCustomerDetails(id: string): Promise<AuditVASCustomerDetailsViewModel[]> {
    const httpResult = await this._httpService.apiGet<AuditVASCustomerDetailsViewModel[]>(`audit/GetVASCustomerDetails/${id}`);
    if (httpResult && httpResult.body) {
      return httpResult.body;
    }
    return [];
  }

  public async GetVASDetails(id: string): Promise<AuditVasDetailsViewModel[]> {
    const httpResult = await this._httpService.apiGet<AuditVasDetailsViewModel[]>(`audit/GetVASDetails/${id}`);
    if (httpResult && httpResult.body) {
      return httpResult.body;
    }
    return [];
  }

  public async GetVSinkNodeMappedFieldsDetails(id: string): Promise<AuditSinkNodeMappedFieldsDetailsViewModel[]> {
    const httpResult = await this._httpService.apiGet<AuditSinkNodeMappedFieldsDetailsViewModel[]>(`audit/GetSinkNodeMappedFieldsDetails/${id}`);
    if (httpResult && httpResult.body) {
      return httpResult.body;
    }
    return [];
  }

  public async GetStructuralDataDetails(id: string): Promise<AuditStructualDataDetailsViewModel[]> {
    const httpResult = await this._httpService.apiGet<AuditStructualDataDetailsViewModel[]>(`audit/GetStructuralDataDetails/${id}`);
    if (httpResult && httpResult.body) {
      return httpResult.body;
    }
    return [];
  }

  public async GetPackedStructuralDataDetails(id: string): Promise<AuditPackedStructualDataDetailsViewModel[]> {
    const httpResult = await this._httpService.apiGet<AuditPackedStructualDataDetailsViewModel[]>(`audit/GetPackedStructuralDataDetails/${id}`);
    if (httpResult && httpResult.body) {
      return httpResult.body;
    }
    return [];
  }

  public async GetMerchantParamsDataDetails(merchantNumber: string): Promise<AuditMerchantParamsViewModel[]> {
    const httpResult = await this._httpService.apiGet<AuditMerchantParamsViewModel[]>(`audit/GetMerchantParamsDataDetails/${merchantNumber}`);
    if (httpResult && httpResult.body) {
      return httpResult.body;
    }
    return [];
  }


  public async GetTerminalDetails(id: string): Promise<AuditTeminalDetailsViewModel[]> {
    const httpResult = await this._httpService.apiGet<AuditTeminalDetailsViewModel[]>(`audit/GetTerminalDetails/${id}`);
    if (httpResult && httpResult.body) {
      return httpResult.body;
    }
    return [];
  }

  public async GetTerminalDetailsByUserId(userId: string): Promise<AuditTeminalDetailsViewModel[]> {
    const httpResult = await this._httpService.apiGet<AuditTeminalDetailsViewModel[]>(`audit/GetTerminalDetailsById/${userId}`);
    if (httpResult && httpResult.body) {
      return httpResult.body;
    }
    return [];
  }

  public async GetLastUserInteraction(userId: string): Promise<AuditLogViewModel> {
    const httpResult = await this._httpService.apiGet<AuditLogViewModel>(`audit/GetLastUserInteraction/${userId}`);
    if (httpResult && httpResult.body) {
      return httpResult.body;
    }
    return null;
  }


  public async GetMerchantDetailsByUserId(id: string): Promise<AuditMerchantViewModel[]> {
    const httpResult = await this._httpService.apiGet<AuditMerchantViewModel[]>(`audit/GetMerchantByIserId/${id}`);
    if (httpResult && httpResult.body) {
      return httpResult.body;
    }
    return [];
  }


  public async GetTerminalInteractionsDetails(id: string): Promise<AuditTerminalInteractionViewModel[]> {
    const httpResult = await this._httpService.apiGet<AuditTerminalInteractionViewModel[]>(`audit/GetTerminalInteractionsDetails/${id}`);
    if (httpResult && httpResult.body) {
      return httpResult.body;
    }
    return [];
  }

  public async GetTerminalCustomParams(id: string): Promise<AuditTeminalCustomParameterViewModel[]> {
    const httpResult = await this._httpService.apiGet<AuditTeminalCustomParameterViewModel[]>(`audit/GetTerminalCustomParameters/${id}`);
    if (httpResult && httpResult.body) {
      return httpResult.body;
    }
    return [];
  }


  public async GetCardAcceptorConfigsByIdentifier(id: string): Promise<AuditCardAcceptorConfigViewModel[]> {
    const httpResult = await this._httpService.apiGet<AuditCardAcceptorConfigViewModel[]>(`audit/GetCardAcceptorConfigsByIdentifier/${id}`);
    if (httpResult && httpResult.body) {
      return httpResult.body;
    }
    return [];
  }

  public async GetTerminalConfigsByIdentifier(id: string): Promise<AuditTerminalConfigViewModel[]> {
    const httpResult = await this._httpService.apiGet<AuditTerminalConfigViewModel[]>(`audit/GetTerminalConfigsByIdentifier/${id}`);
    if (httpResult && httpResult.body) {
      return httpResult.body;
    }
    return [];
  }
}
